import { render, staticRenderFns } from "./testIndex.vue?vue&type=template&id=5112096e&scoped=true&"
import script from "./testIndex.vue?vue&type=script&lang=js&"
export * from "./testIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112096e",
  null
  
)

export default component.exports